// TranscribeBar.js
import React from 'react';

const TranscribeBar = ({ volume, threshold }) => (
  <div style={{ marginTop: '1rem' }}>
    <strong>🎧 Escuchando...</strong>
    <div
      style={{
        width: '100%',
        height: '10px',
        background: '#ccc',
        borderRadius: '5px',
        overflow: 'hidden'
      }}
    >
      <div
        style={{
          width: `${Math.min(volume * 500, 100)}%`,
          height: '10px',
          background: volume < threshold ? 'red' : 'green',
          transition: 'width 0.1s ease-in-out'
        }}
      />
    </div>
  </div>
);

export default TranscribeBar;
